(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["weekly-mattress-deals"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    const money = value => new Intl.NumberFormat(labels.locale, {style:'currency',currency:labels.currency}).format(value / 100);
    root.querySelectorAll('.wmd-card').forEach(card => {
      const buttons = Array.from(card.querySelectorAll('[data-size]'));
      const show = button => {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const price = Number(button.dataset.price), compare = Number(button.dataset.compare);
        const context = card.querySelector('.wmd-context');
        context.textContent = button.dataset.title + (compare > price ? ' · ' : '');
        if (compare > price) {const old = document.createElement('del'); old.textContent = money(compare); context.appendChild(old);}
        card.querySelector('[data-price-text]').textContent = money(price);
        const badge = card.querySelector('.wmd-off'); badge.hidden = compare <= price;
        badge.textContent = compare > price ? Math.floor((compare-price)/compare*100) + '% OFF' : '';
        card.querySelectorAll('a').forEach(link => link.href = button.dataset.url);
        card.querySelector('[data-stock]').textContent = button.dataset.available === 'true' ? '✓ ' + labels.stock : labels.sold;
      };
      if (buttons.length) show(buttons.find(item => item.getAttribute('aria-pressed') === 'true') || buttons[0]);
      buttons.forEach(button => button.addEventListener('click', () => show(button)));
    });
    const track = root.querySelector('.wmd-track'), previous = root.querySelector('.wmd-prev'), next = root.querySelector('.wmd-next'), play = root.querySelector('[data-play]');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    let paused = reduced.matches, hovered = false, visible = false, interval;
    const move = direction => {const card = track.firstElementChild;if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:reduced.matches?'instant':'smooth'});};
    const update = () => {previous.disabled = track.scrollLeft < 2;next.disabled = track.scrollLeft >= track.scrollWidth-track.clientWidth-2;};
    const schedule = () => {clearInterval(interval);play.textContent=paused?labels.play:labels.pause;play.hidden=track.scrollWidth<=track.clientWidth+2;if(paused||hovered||!visible||document.hidden||reduced.matches||play.hidden)return;interval=setInterval(()=>{if(!root.isConnected){clearInterval(interval);return;}if(next.disabled)track.scrollTo({left:0,behavior:'smooth'});else move(1);},3000);};
    const stop = () => {paused=true;schedule();};
    previous.addEventListener('click',()=>{stop();move(-1);}); next.addEventListener('click',()=>{stop();move(1);});play.addEventListener('click',()=>{paused=!paused;schedule();});
    root.addEventListener('mouseenter',()=>{hovered=true;schedule();});root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
    root.addEventListener('focusin',event=>{if(event.target!==play)stop();});track.addEventListener('pointerdown',stop,{passive:true});
    track.addEventListener('keydown',event=>{if(event.target===track&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();stop();move(event.key==='ArrowRight'?1:-1);}});
    track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.5}).observe(root);
    document.addEventListener('visibilitychange',schedule);reduced.addEventListener('change',()=>{if(reduced.matches)paused=true;schedule();});update();
    const clock = root.querySelector('.wmd-countdown');
    const tick = () => {
      if(!root.isConnected){clearInterval(timer);return;}
      const values = ['days','hours','minutes','seconds'].map(unit=>{const source=document.querySelector('.real-urgency-countdown [data-ru-'+unit+']')||document.querySelector('[data-ru-cd-'+unit+']');return source?Number(source.textContent):NaN;});
      clock.hidden=values.some(Number.isNaN)||values.every(value=>value===0);
      if(!clock.hidden)clock.querySelector('[data-clock]').textContent=(values[0]>0?values[0]+'d : ':'')+values.slice(1).map((value,index)=>String(value).padStart(2,'0')+['h','m','s'][index]).join(' : ');
    };
    const timer=setInterval(tick,1000);tick();
  };
  document.querySelectorAll('.wmd').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.wmd').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
